module.exports = __webpack_public_path__ + "static/media/banner.764f3ec8.png";